// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/follow-us-on-instagram/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const followUsOnInstagramDE: PageEntry = {
  id: "post.follow-us-on-instagram",
  locale: "de",
  slug: "follow-us-on-instagram",
  seo: {
    title: "Follow us on Instagram | Dietz GmbH",
    description: "Follow us on Instagram",
  },
  type: "post",
  h1: "Follow us on Instagram",
  blocks: [
    { kind: "heading", level: 2, text: "Follow us on Instagram" },
    { kind: "paragraph", text: "Ab jetzt habt ihr neben Facebook, Xing und LinkedIn auch (wieder) die Möglichkeit uns auf Instagram zu folgen! Hier möchten wir euch spannende Einblicke in unseren Arbeitsalltag geben und euch über Neuigkeiten auf dem Laufenden halten." },
    { kind: "paragraph", text: "Wir freuen uns über eure Kontaktanfragen und jeden neuen Follower." },
    { kind: "paragraph", text: "Hier geht’s direkt zum Profil: https://www.instagram.com/dietzgmbh/" }
  ],
};
